const useTabTransition = () => {
    const hideElement = document.querySelectorAll(".hide");

    hideElement.forEach((data) => {
        data.classList.remove("show");
    });

    setTimeout(() => {
        hideElement.forEach((data) => {
            data.classList.add("show");
        });
    }, 100);
};

export default useTabTransition;
